import { render, staticRenderFns } from "./OneClickOrderBadge.vue?vue&type=template&id=49d1b6d2&scoped=true&"
import script from "./OneClickOrderBadge.vue?vue&type=script&lang=js&"
export * from "./OneClickOrderBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d1b6d2",
  null
  
)

export default component.exports